<template>
  <page-wrapper :title="$t('global.error')">
    <v-row>
      <v-col md="7">
        <v-card>
          <v-card-title>
            {{ $t('page.error.authenticationError.card.title') }}
          </v-card-title>
          <v-card-subtitle>
            {{ $t('page.error.authenticationError.card.description') }}
          </v-card-subtitle>
          <v-card-text>
            <dl class="d-grid grid-4060 mt-2">
              <dt>{{ $t('global.error.dateUTC') }}</dt>
              <dd>{{ currentDate.toISOString() }}</dd>
              <template v-if="!isNil(threadIdentifier)">
                <dt>{{ $t('global.error.errorReference') }}</dt>
                <dd>{{ threadIdentifier }}</dd>
              </template>
            </dl>
          </v-card-text>
          <v-card-actions class="mt-10 justify-end">
            <c-btn type="primary" :to="{ name: 'home' }" style="min-width:120px">
              {{ $t('global.returnHome') }}
            </c-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </page-wrapper>
</template>

<script>
import _ from 'lodash';
import PageWrapper from '@components/support/PageWrapper';
import PageMixin from '@/mixins/page';

export default {
  components: { PageWrapper },
  mixins: [ PageMixin ],
  data () {
    return {
      currentDate: new Date()
    };
  },
  computed: {
    threadIdentifier () {
      return _.get(this.$route, 'query.threadIdentifier', null);
    }
  }
};
</script>

<style lang="scss" scoped>
dd
{
  font-family: monospace;
}
</style>